import React from "react";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import PersonTopFields from "@/components/layouts/PersonTopFields";
import { PersonData } from "@/entities/people/types";
import PersonDetailFields from "@/components/layouts/PersonDetailFields/PersonDetailFields";
import InvolvedIn from "@/components/layouts/InvolvedIn";
import NextSteps from "@/components/layouts/NextSteps/NextSteps";
import PersonKPIs from "@/pages/people/components/PersonKPIs";

interface Props {
  person: PersonData | undefined;
  onUpdatePersonField: (
    field: string,
    newValue: string | number | boolean | string[],
    additionalFields?:
      | {
          [fieldName: string]: string | number;
        }
      | undefined,
    successToastText?: string | undefined,
    onSuccessFn?: (() => void) | undefined,
    isDetailedView?: boolean | undefined,
    hideSuccessToast?: boolean | undefined,
    queryParams?: Record<string, string> | undefined
  ) => void;
  onCreateLead: () => void;
  onCreateDeal: () => void;
  onCreateContract?: () => void;
}

const PersonQuickViewContent: React.FC<Props> = ({
  person,
  onUpdatePersonField,
  onCreateLead,
  onCreateDeal,
  onCreateContract
}) => {
  return (
    <div className="flex flex-col gap-4 w-full">
      <PersonTopFields
        className="flex-wrap gap-0 pl-5 pr-0"
        person={person}
        onUpdateField={onUpdatePersonField}
      />
      <div className="flex flex-col w-full gap-4 pl-5">
        <PersonKPIs
          person={person}
          containerClassName="grid-cols-[repeat(auto-fill,minmax(12rem,12rem))]"
          isQuickView
          onUpdateField={(field, newValue) =>
            onUpdatePersonField(field, newValue)
          }
        />
        <InvolvedIn
          entityId={person?.id || ""}
          entityType={EntityType.PERSON}
          className="min-h-fit"
          isQuickView
          onCreateLead={onCreateLead}
          onCreateDeal={onCreateDeal}
          onCreateContract={onCreateContract}
        />
        <PersonDetailFields
          className="w-full px-4 min-h-fit"
          person={person}
          onUpdateField={onUpdatePersonField}
          containerClassName="grid-cols-[minmax(0,30%),1fr]"
          isDrawerOpen={true}
          isQuickView
        />
        <NextSteps
          className="w-full px-4"
          entity={person}
          entityType={EntityType.PERSON}
          isQuickView
        />
      </div>
    </div>
  );
};

export default PersonQuickViewContent;
